<mat-form-field>
  <mat-select [(ngModel)]="selectedLanguage" (selectionChange)="onLanguageChange()">
    <mat-option *ngFor="let lang of languages" [value]="lang"> {{ lang }} </mat-option>
  </mat-select>
</mat-form-field>
